/*
 *
 * SelectTextFilterEditor constants
 *
 */


export const LOAD_ENTITY = 'claris-vnext/AdvancedDataTable/SelectTextFilterEditor/LOAD_ENTITY';
export const ADD_ENTITY_TO_STATE = 'claris-vnext/AdvancedDataTable/SelectTextFilterEditor/ADD_ENTITY_TO_STATE';
